import { render, staticRenderFns } from "./edit-CallCenter.vue?vue&type=template&id=e27445f0"
import script from "./edit-CallCenter.vue?vue&type=script&lang=ts"
export * from "./edit-CallCenter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports